import { render, staticRenderFns } from "./account-setup.component.vue?vue&type=template&id=1db97187"
import script from "./account-setup.component.ts?vue&type=script&lang=ts&external"
export * from "./account-setup.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1db97187')) {
      api.createRecord('1db97187', component.options)
    } else {
      api.reload('1db97187', component.options)
    }
    module.hot.accept("./account-setup.component.vue?vue&type=template&id=1db97187", function () {
      api.rerender('1db97187', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin-panel/account-setup/account-setup.component.vue"
export default component.exports